document.addEventListener('alpine:init', () => {
  Alpine.data('carousel', (randomize = false) => ({
    randomize: randomize,
    container: null,
    prev: null,
    next: null,
    init() {
      this.container = this.$refs.container
      if (this.randomize) {
        this.shuffleElements();
      }
      this.update();
      this.container.addEventListener('scroll', this.update.bind(this), {
        passive: true
      });
    },
    update() {
      const rect = this.container.getBoundingClientRect();
      const visibleElements = Array.from(this.container.children).filter((child) => {
        const childRect = child.getBoundingClientRect()
        return childRect.left >= rect.left && childRect.right <= rect.right;
      });
      if (visibleElements.length > 0) {
        this.prev = this.getPrevElement(visibleElements);
        this.next = this.getNextElement(visibleElements);
      }
    },
    shuffleElements() {
      for (var i = this.container.children.length; i >= 0; i--) {
        this.container.appendChild(this.container.children[Math.random() * i | 0]);
      }
    },
    getPrevElement(list) {
      const sibling = list[0].previousElementSibling;
      if (sibling instanceof HTMLElement) {
        return sibling;
      }
      return null;
    },
    getNextElement(list) {
      const sibling = list[list.length - 1].nextElementSibling;
      if (sibling instanceof HTMLElement) {
        return sibling;
      }
      return null;
    },
    scrollTo(element) {
      const current = this.container;
      if (!current || !element) return;
      const nextScrollPosition = element.offsetLeft + element.getBoundingClientRect().width / 2 - current.getBoundingClientRect().width / 2;
      current.scroll({
        left: nextScrollPosition,
        behavior: 'smooth',
      });
    }
  }));
  Alpine.data('menuSlide', () => ({
    slideOpen: false,
    showModal: false,
    cart: {},
    init() {
      this.cartInit();
    },
    cartInit() {
      var self = this;
      this.cartAPI('GET', '/cart.js', function(response) {
        // self.buildCart(response);
        self.cart = response;
        console.log(self.cart);
      });
    },
    cartAPI(action, URL, callback) {
      var self = this;
      this.cart = {
        loading: true
      };
      var anHttpRequest = new XMLHttpRequest();
      anHttpRequest.onreadystatechange = function() {
        if (anHttpRequest.readyState == 4 && anHttpRequest.status == 200) {
          if (self.hasJsonStructure(anHttpRequest.response)) {
            callback(JSON.parse(anHttpRequest.response));
          } else {
            callback();
          }
        }
      }
      anHttpRequest.open(action, URL, true);
      anHttpRequest.send(null);
    },

    //** This function was needed to facilitate the bundle building before shopify functions. It is no longer needed, maybe :) ? **//
    // buildCart(response) {
    //   this.cart = response;
    //   this.cart['line_items'] = {};
    //   this.cart['display_count'] = 0; // used for number overlay on cart icon
    //   for (let i = 0; i < response['items'].length; i++) {
    //     this.cart['line_items'][i] = response['items'][i];
    //     if (response['items'][i]['properties']) { // check to see if line_item is a customized product
    //       this.cart['line_items'][i]['customization'] = {};
    //       this.cart['line_items'][i]['isAddonItem'] = false;
    //       for (property in response['items'][i]['properties']) {
    //         if (property.includes('customize_')) {
    //           this.cart['line_items'][i]['customization'][property] = response['items'][i]['properties'][property];
    //           var customizationCost = (Number(response['items'][i]['properties'][property]['price']) > 0) ? Number(response['items'][i]['properties'][property]['price']) : 0;
    //           this.cart['line_items'][i]['price'] = Number(this.cart['line_items'][i]['price']) + customizationCost;
    //         } else if (property == 'defaults_addon_price') {
    //           this.cart['line_items'][i]['price'] = Number(this.cart['line_items'][i]['price']) - Number(response['items'][i]['properties'][property]);
    //         }
    //       }
    //     }
    //     if(this.cart['line_items'][i].properties == null || this.cart['line_items'][i].properties.isAddonItem == undefined){
    //       this.cart['display_count']++;
    //     }
    //   }
    //   console.log(this.cart);
    // },


    emptyCart(){
      var self = this;
      fetch('/cart/clear.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        }
      })
      .then(response => {
        self.cartInit();
      })
      .catch((error) => {
        console.error('Error:', error);
      });
    },
    removeCartItem(line) {
      var self = this;
      var lineQty = [];
      for ( line_item in self.cart.items ) {
        if ( line_item == line ) {
          lineQty.push(0)
        } else {
          lineQty.push( self.cart.items[line_item]['quantity'] )
        }
      }
      // var bundle_id_check = [];
      // for (line_item in self.cart['line_items']) {
      //   // if( line_item != line && 'bundle_id' in self.cart['line_items'][line]['properties'] && 'bundle_id' in self.cart['line_items'][line_item]['properties'] ){ // collect bundle IDs in the cart that aren't the item to be removed
      //   //   bundle_id_check.push( parseInt( self.cart['line_items'][line_item]['properties']['bundle_id'] ) );
      //   // }
      //   if (line_item == line || ( 'isAddonItem' in self.cart['line_items'][line_item]['properties'] && parseInt( self.cart['line_items'][line_item]['properties']['isAddonItem'] ) == parseInt( self.cart['line_items'][line]['properties']['bundle_id'] ) ) ) { // if line item is the one to remove or is a customized line item belonging to the one being removed
      //     lineQty.push(0); // remove line item
      //   } else {
      //     lineQty.push(self.cart['line_items'][line_item]['quantity']); // keep quantity the same for this line
      //   }
      // }
      // if( 'bundle_id' in self.cart['line_items'][line]['properties'] ){
      //   for (line_item in self.cart['line_items']) { // double check that there are no orphaned addonItems
      //     if( 'isAddonItem' in self.cart['line_items'][line_item]['properties'] && !bundle_id_check.includes( parseInt(self.cart['line_items'][line_item]['properties']['isAddonItem'] ) ) ){
      //       lineQty[ line_item ] = 0;
      //     }
      //   }
      // }
      fetch('/cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            updates: lineQty
          })
        })
        .then(response => {
          self.cartInit();
        })
        .catch((error) => {
          console.error('Error:', error);
        });
    },
    addToCart(form) {
      var self = this;
      var formData = new FormData(form);
      console.log(Array.from(formData.entries()));
      fetch('/cart/add.js', {
          method: 'POST',
          body: formData
        })
        .then(response => {
          response.json().then(line_item => {
            self.cartInit();
            self.slideOpen = 'cart_open';
          });
        })
        .catch((error) => {
          console.error('Error:', error);
        });
    },
    currencyFormatter(value) {
      var formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD'
      });
      return formatter.format(value / 100);
    },
    hasJsonStructure(str) {
      if (typeof str !== 'string') return false;
      try {
        const result = JSON.parse(str);
        const type = Object.prototype.toString.call(result);
        return type === '[object Object]' ||
          type === '[object Array]';
      } catch (err) {
        return false;
      }
    }
  }));
  Alpine.data('mobileNav', () => ({
    mobileMenu: [],
    init() {},
    mobileMenuClick(key, value, link = false) {
      if (this.mobileMenu[key] == value && link) {
        window.location.href = link.href;
      } else {
        this.mobileMenu[key] = value;
        if (key < 2) {
          this.mobileMenu[2] = 0;
        }
      }
    }
  }));
  Alpine.data('search', () => ({
    query: '',
    searchResults: {
      message: 'initial'
    },
    init() {
      this.$watch('query', (value) => this.formSubmit());
    },
    formSubmit() {
      if (this.query && this.query != '') {
        fetch('/search/suggest.json?q=' + this.query + '&resources[type]=product,page,article,collection&section_id=predictive-search&resources[options][fields]=title,product_type,variants.title,variants.sku')
          .then(response => {
            return response.json();
          })
          .then(data => {
            this.searchResults = {
              message: 'none_found'
            };
            for (result in data.resources.results) {
              if (data.resources.results[result].length > 0) {
                this.searchResults[result] = data.resources.results[result];
                this.searchResults['message'] = false;
              }
            }
            //console.log(this.searchResults);
          })
          .catch((error) => {
            console.error('Error:', error);
          });
      } else {
        this.searchResults = {
          message: 'initial'
        }
        // console.log(this.searchResults);
      }
    }
  }));
});